module.exports = __webpack_public_path__ + "static/media/Ciclo.13e3d5a7.png";